// extracted by mini-css-extract-plugin
export default {"minorFooter":"MinorFooter_minorFooter__UbAP4","rights":"MinorFooter_rights__NcgSJ","isLogin":"MinorFooter_isLogin__jRqUH"};